<template>
  <a-popconfirm
    :title="alertTitle"
    @confirm="$emit('onDelete')"
    okText="确定"
    cancelText="取消"
  >
    <a href="javascript:;">{{ text }}</a>
  </a-popconfirm>
</template>
<script>
export default {
  props: ['text', 'alertTitle'],
  data() {
    return {};
  },
};
</script>
